import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Card, CardBody } from "reactstrap";

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from "../Layout/Meta";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Registrar os módulos necessários do ChartJS
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChartXMultiLine = ({ item }) => {
  const safeItem = item || {};
  const {
    Sigla = '',
    Descricao_Dashboard_Componente: titulo = "-",
    dadosComponente = {},  
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = "",
    opcoesComponente,
  } = safeItem;

  // Controle do Modal (caso mantenha)
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => setIsPopupOpen(!isPopupOpen);
  const slugId = Sigla.trim().replace(/\s+/g, "-");
  
  return (
    <Card className="w-100 h-100">
      <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
        <CardHeader
          titulo={titulo}
          Texto_Info={Texto_Info}
          ESG_Info={ESG_Info}
          togglePopup={togglePopup}
          slugId={slugId}
          textoIA={Texto_BizAI}
          Codigo_Transacao_Link={Codigo_Transacao_Link}
          Titulo_Transacao_Link={Titulo_Transacao_Link}
        />

        {/* Metas e Valores */}
        <Meta Valor_Meta={Valor_Meta} />

        <div style={{ marginTop: "20px", height: "100%", width: "100%" }}>
          <Bar data={dadosComponente} options={opcoesComponente} />
        </div>
      </CardBody>

      {/* Modal de Insights (caso mantenha) */}
      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI}
      />
    </Card>
  );
};

export default BarChartXMultiLine;
